
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PlayerConfig } from '@/interfaces/player-config.interface';

@Component
export default class StopLiveTemplate extends Vue {
  public wcomStyle: any = 'none';
  public isFadingOut: boolean = false;

  @Prop() private playerConfig!: PlayerConfig;

  private mounted() {
    if (this.playerConfig.accountId === 'wcom') {
      this.wcomStyle = { 'background-image': 'url(' + this.playerConfig.previewImage + ')' };
    }
  }

  private handleClick() {
    // Start fade-out animation (but don't delay the process)
    this.isFadingOut = true;

    // Emit immediately - transition is visual only
    this.$emit('resume');
  }
}
